import { ILineBreakBehavior, ILineBreakBehaviorSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanTextDrawable } from "../../../beans/objects";

export class LineBreakBehaviorTranslator {
  from(bean: IObjectBeanTextDrawable): ILineBreakBehavior {
    return {
      isEnable: (bean["@line-break"] === "1"),
    };
  }

  to(o: ILineBreakBehaviorSpecifiable) {
    return {
      lineBreak: o.lineBreakBehavior.isEnable
        ? "1"
        : undefined,
    };
  }
}
